import { render, staticRenderFns } from "./MapBrands.vue?vue&type=template&id=f42e5598&lang=html&"
import script from "./MapBrands.vue?vue&type=script&lang=js&"
export * from "./MapBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports